import { LaunchPlatformModal } from 'components/Search/SeawareBranch/LaunchPlatformModal';
import {
  createContext,
  useContext,
  ReactNode,
  useMemo,
  useCallback,
  useState,
} from 'react';
import { IContactInfo, useGetContactInfoQuery } from 'store/services/contact';

type LaunchSeawarePlatformContextType = {
  isLaunchSeawarePlatformModalVisible: boolean;
  showLaunchSeawarePlatformModal: () => void;
  hideLaunchSeawarePlatformModal: () => void;
  contactInfo: IContactInfo | null;
};

const launchSeawarePlatformDefaultValues: LaunchSeawarePlatformContextType = {
  isLaunchSeawarePlatformModalVisible: false,
  showLaunchSeawarePlatformModal: () => {},
  hideLaunchSeawarePlatformModal: () => {},
  contactInfo: null,
};

const LaunchSeawarePlatformContext =
  createContext<LaunchSeawarePlatformContextType>(
    launchSeawarePlatformDefaultValues
  );

export function useLaunchSeawarePlatformContext() {
  return useContext(LaunchSeawarePlatformContext);
}

type ProviderProps = {
  readonly children: ReactNode;
};

export function LaunchSeawarePlatformContextProvider({
  children,
}: ProviderProps) {
  const [
    isLaunchSeawarePlatformModalVisible,
    setIsLaunchSeawarePlatformModalVisible,
  ] = useState(false);
  const { data: contactInfo } = useGetContactInfoQuery();

  const showLaunchSeawarePlatformModal = useCallback(
    () => setIsLaunchSeawarePlatformModalVisible(true),
    [setIsLaunchSeawarePlatformModalVisible]
  );
  const hideLaunchSeawarePlatformModal = useCallback(
    () => setIsLaunchSeawarePlatformModalVisible(false),
    [setIsLaunchSeawarePlatformModalVisible]
  );

  return (
    <LaunchSeawarePlatformContext.Provider
      value={useMemo(
        () => ({
          isLaunchSeawarePlatformModalVisible,
          showLaunchSeawarePlatformModal,
          hideLaunchSeawarePlatformModal,
          contactInfo,
        }),
        [
          isLaunchSeawarePlatformModalVisible,
          showLaunchSeawarePlatformModal,
          hideLaunchSeawarePlatformModal,
          contactInfo,
        ]
      )}
    >
      <>
        {children}
        <LaunchPlatformModal
          onClose={hideLaunchSeawarePlatformModal}
          isOpen={isLaunchSeawarePlatformModalVisible}
        />
      </>
    </LaunchSeawarePlatformContext.Provider>
  );
}
